var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeafWithBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 32,
    height: 32,
    rx: 4.8,
    fill: "#F1F8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2624 9.73828C24.1687 9.55078 23.9812 9.42578 23.7937 9.42578C23.6374 9.42578 23.4812 9.51953 23.3562 9.70703C22.3874 11.3945 20.6687 12.4258 18.6999 12.4258H16.1999C12.8874 12.4258 10.1999 15.1133 10.1999 18.4258C10.1999 18.9883 10.2624 19.5195 10.4187 20.0508C8.10616 22.0508 7.23116 24.3945 7.23116 24.457C7.10616 24.832 7.29366 25.2695 7.69991 25.3945C8.13741 25.5508 8.51241 25.2695 8.63741 24.9258C8.66866 24.8945 9.29366 23.1445 11.0124 21.4883C12.1999 23.457 14.4187 24.6445 16.8249 24.3945C21.7312 24.0508 25.1999 19.6445 25.1999 14.2695C25.1999 12.707 24.8562 11.082 24.2624 9.73828ZM16.6687 22.9258C13.9812 23.207 12.5749 21.207 12.2312 20.5195C13.6999 19.4883 15.7312 18.6758 18.4499 18.6758C18.8562 18.6758 19.1999 18.3633 19.1999 17.9258C19.1999 17.5195 18.8562 17.1758 18.4499 17.1758C15.5749 17.1758 13.4187 17.9883 11.7624 19.0508C11.7312 18.832 11.6999 18.6445 11.6999 18.4258C11.6999 15.957 13.6999 13.9258 16.1999 13.9258H18.6999C20.5124 13.9258 22.1687 13.2383 23.4499 12.0508C23.6062 12.7695 23.6999 13.5195 23.6999 14.2695C23.6999 18.9883 20.7624 22.6133 16.6687 22.9258Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafWithBackground);
export default __webpack_public_path__ + "static/media/leaf-with-background.bae9cc36eeb707de1b4cad487d0d152d.svg";
export { ForwardRef as ReactComponent };